export const CONTROL_BAR_CLASS_NAME = 'vjs-control-bar';
export const QUALITY_MENU_WRAPPER_CLASS_NAME = 'vjs-quality-menu-wrapper';
export const PLAY_CONTROL_CLASS_NAME = 'vjs-play-control';
export const POSTER_CLASS_NAME = 'vjs-poster';
export const VOLUME_BUTTON_CLASS_NAME = 'vjs-volume-panel';
export const HIDDEN_ELEMENT_CLASS_NAME = 'vjs-hidden';
export const VOLUME_CONTROL_CLASS_NAME = 'vjs-volume-control';
export const VOLUME_TOOLTIP_CLASS_NAME = 'vjs-volume-tooltip';
